import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'


const EnergySubscriber = (props) => {

  return (
    <div className='subscriber'>
      <div className='title'>
        <span className='text'>{props.subscriber.customerAddress?.trim().replace(/^,|,$/g, '')}</span></div>
    </div>
  );

}

export default EnergySubscriber;

